import React, { createContext, useReducer } from "react";
import { ROLE } from "../utils/constant";
import { findItemInResults } from "./action";

const initialState = {
  loading: false,
  addAddressMode: false,
  addLocation: [],
  latlng: [],
  selectedObject: null,
  selectedAddress: '',
  addressResult: [],
  error: '',
  province: 25,
  flyToCity: [],
  flyToLocation: [],
  loadingAddress: false,
  notFound: false,
  role: ROLE.USER,
  editMode: false,
  editedLocation: [],
};

const store = createContext(initialState);

// reducer switch case
const StateProvider = ({ children }) => {
  const [state, dispatch] = useReducer((state, action) => {
    switch (action.type) {
      case "EDIT_MODE":
        return {
          ...state, editMode: action.state, editedLocation: action.state ? state.latlng : []
        };
      case "SHOW_LOADING":
        return { ...state, loading: true, addressResult: [] };
      case "RESET_MAP":
        return { ...state, latlng: [] };
      case "ADD_ADDRESS_MODE":
        return { ...state, addAddressMode: action.state };
      case "ADD_LOCATION":
        return { ...state, addLocation: action.location };
      case "FLY_TO_CITY":
        return { ...state, flyToCity: action.coords };
      case "FLY_TO_LOCATION":
        return { ...state, flyToLocation: action.coords };
      case "HIDE_LOADING":
        return { ...state, loading: false };
      case "SET_PROVINCE":
        return { ...state, province: action.prov };
      case "SEARCH_RESULT":
        return { ...state, addressResult: [...action.result] };
      case "SET_LATLNG":
        return { ...state, latlng: action.latlng };
      case "SET_ADDRESS":
        return { ...state, selectedAddress: action.address, selectedObject: findItemInResults(state.addressResult, action.address, action.item) };
      case "LOADING_ADDRESS":
        return { ...state, loadingAddress: action.state };
      case "NOT_FOUND_ADDRESS":
        return { ...state, notFound: action.state };
      case "CLEAR_SELECTED_ADDRESS":
        return { ...state, selectedAddress: '', latlng: [], selectedObject: null, };
      case "SET_ROLE":
        return { ...state, role: action.role || ROLE.USER };
      case "CHANGE_LOCATION":
        return {
          ...state, editedLocation: action.location || state.editedLocation
        };
      default:
        throw new Error();
    }
  }, initialState);

  return (
    <store.Provider value={{ state, dispatch }}>{children}</store.Provider>
  );
};

export { store, StateProvider };
